import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import { getBootDecision, bootDocumentTitle } from './lib/tenants'
import { UnknownOrganization } from './pages/UnknownOrganization'

const boot = getBootDecision()

if (boot.kind === 'redirect') {
  // Apex / www → send to the default tenant subdomain. Do not mount the app.
  window.location.replace(boot.to)
} else {
  // Title the tab for the resolved tenant (spec §11), overriding index.html's
  // neutral static fallback so a second tenant's tab never reads "MUAA".
  document.title = bootDocumentTitle(boot)
  const root = ReactDOM.createRoot(document.getElementById('root')!)
  root.render(
    <React.StrictMode>
      {boot.kind === 'unknown' ? <UnknownOrganization slug={boot.slug} /> : <App />}
    </React.StrictMode>,
  )
}
